import PropTypes from 'prop-types';

import SvgColorImg from '../SvgColorImg';

import gcatCodeIconSrc from './gcatCodeIconSrc';

function GcatCodeIcon(props) {
  const {
    gcatCode,
    symbol,
    canReturnNull,
    className,
  } = props;

  const src = gcatCodeIconSrc(gcatCode, !symbol, canReturnNull);
  if (!src) return null;

  return (
    <SvgColorImg
      src={src}
      className={className}
      imgColorAsCssFill
    />
  );
}

GcatCodeIcon.propTypes = {
  gcatCode: PropTypes.string,
  symbol: PropTypes.bool,
  canReturnNull: PropTypes.bool,
  className: PropTypes.string,
};

export default GcatCodeIcon;
